module.exports = __webpack_public_path__ + "static/media/dineOutMenu.1510624d.pdf";